import type { FormOptionValue } from '../../types/form/form-fields/field-values';

export interface ScaleLabels {
	leftLabel?: string;
	middleLabel?: string;
	rightLabel?: string;
}

/**
 * Derives the scale end labels from the options.
 * Labels are stored in the first three options' label fields:
 *   options[0].label = leftLabel
 *   options[1].label = rightLabel
 *   options[2].label = middleLabel
 */
export const getScaleLabelsFromOptions = (options?: FormOptionValue[]): ScaleLabels => {
	if (!options || options.length === 0) {
		return {};
	}
	return {
		leftLabel: options[0]?.label || undefined,
		rightLabel: options[1]?.label || undefined,
		middleLabel: options[2]?.label || undefined,
	};
};
